module.exports = __webpack_public_path__ + "img/hr-sand-decal-17.996f076f.png";